import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { fetchList, fetchDelete } from '@/api/PMS/companyManage/companyManage';
import waves from '@/directive/waves'; // 水波纹指令

import posAdd from './add';
export default {
  name: 'ComplexTable',
  components: {
    posAdd: posAdd
  },
  directives: {
    waves: waves
  },
  data: function data() {
    return {
      list: null,
      total: null,
      listLoading: true,
      listQuery: {
        page: 1,
        limit: 10,
        companyName: ''
      },
      title: '',
      posId: -1,
      multipleSelection: [],
      dialogFormVisible: false
    };
  },
  created: function created() {
    this.getList();
  },
  methods: {
    handCancle: function handCancle(reload) {
      if (reload) {
        this.getList();
      }

      this.dialogFormVisible = false;
    },
    getList: function getList() {
      var _this = this;

      this.listLoading = true;
      fetchList(this.listQuery).then(function (response) {
        _this.list = response.data.data;
        _this.total = response.data.total;
        _this.listLoading = false;
      });
    },
    handleFilter: function handleFilter() {
      this.listQuery.page = 1;
      this.getList();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.listQuery.limit = val;
      this.getList();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.listQuery.page = val;
      this.getList();
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // 创建
    handleCreate: function handleCreate() {
      this.posId = -1;
      this.title = '创建';
      this.dialogFormVisible = true;
    },
    // 编辑
    handleUpdate: function handleUpdate(posId) {
      this.posId = posId;
      this.title = '编辑';
      this.dialogFormVisible = true;
    },
    delete: function _delete(posIds) {
      var _this2 = this;

      if (posIds.length > 0) {
        this.$confirm('你确定是要删除这些记录, 是否继续?', '提示').then(function () {
          fetchDelete(posIds).then(function (response) {
            _this2.getList();

            _this2.Alert({
              alertType: 'delete'
            });
          });
        });
      } else {
        this.Alert({
          alertType: 'nodata'
        });
      }
    },
    handleDelete: function handleDelete(posId) {
      var posIds = [];
      posIds.push(posId);
      this.delete(posIds);
    },
    handleDeletes: function handleDeletes() {
      var posIds = [];
      this.multipleSelection.forEach(function (row) {
        posIds.push(row.id);
      });
      this.delete(posIds);
    }
  }
};